import gql from 'graphql-tag';

export const GET_CLIENT_MAX_MARKETPLACE_PROJECTS_COUNT_QUERY = gql`
  query GetClientMaxMarketplaceProjectsCountQuery {
    count: getClientMaxMarketplaceProjectsCount
  }
`;
